import { FunctionComponent } from 'react'
import classNames from 'classnames'
import { ProductCardCollapsed as ProductCardCollapsedProps } from './ProductCardCollapsed.types'
import { Label } from '../primitives/Label/Label'
import { AddToCartCollapsedButton } from '../AddToCartCollapsedButton/AddToCartCollapsedButton'
import { ProductCardCollapsedPrice } from '../ProductCardCollapsedPrice/ProductCardCollapsedPrice'
import { useActions } from 'src/hooks/useActions'
import { useMealActions } from 'src/hooks/coreUx/useMealActions'
import './ProductCardCollapsed.scss'

export const ProductCardCollapsed: FunctionComponent<ProductCardCollapsedProps> = ({
  attributes,
  data
}) => {
  const { title, description, image, actions, addToCart } = attributes
  const { onClick } = useActions(actions)
  const { planIsCompleted } = useMealActions(data, undefined, undefined)

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onClick()
    }
  }

  return (
    <div
      className="core-ux-product-card-collapsed"
      onClick={onClick}
      tabIndex={0}
      role="button"
      aria-label={data.properties.name}
      onKeyDown={handleKeyDown}>
      <img
        src={image.attributes.url}
        alt={title.attributes.text.attributes.value}
        className="core-ux-product-card-collapsed__image"
      />
      <div className="core-ux-product-card-collapsed__content">
        <div
          className={classNames('core-ux-product-card-collapsed__title', {
            'core-ux-product-card-collapsed__title--one-line': planIsCompleted
          })}>
          <Label {...title} />
        </div>
        <div className="core-ux-product-card-collapsed__description">
          <Label {...description} />
        </div>
        {planIsCompleted && (
          <ProductCardCollapsedPrice
            product={data}
            className="core-ux-product-card-collapsed__price"
          />
        )}
      </div>
      {addToCart && (
        <div
          onClick={e => e.stopPropagation()}
          onKeyDown={e => e.stopPropagation()}
          className="core-ux-product-card-collapsed__add-button"
          role="button"
          aria-label="Add to cart"
          tabIndex={0}>
          <AddToCartCollapsedButton {...addToCart} product={data} />
        </div>
      )}
    </div>
  )
}
